module.exports = __webpack_public_path__ + "img/2.adea7800.jpg";